import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';

import { SharedDataService } from '../../services/shared-data.service';


@Component({
  selector: 'app-drawing-section',
  templateUrl: './drawing-section.component.html',
  styleUrls: ['./drawing-section.component.css']
})
export class DrawingSectionComponent implements OnInit, AfterViewInit {
  @ViewChild('canvas') canvas: ElementRef;
  public context: CanvasRenderingContext2D;
  standardLineSize;

  pathsTable = [];
  sizeTable = {
    'petit': 0.5,
    'moyen': 1,
    'grand': 2
  };
  directionTable = {
    'haut': 'up',
    'bas': 'down',
    'droite': 'right',
    'gauche': 'left'
  };


  constructor(private sharedDateService: SharedDataService) {
    this.sharedDateService.getDialogflowAnswer().subscribe(
      res => {
        this.analyseResponse(res['result']);
      }
    );
  }

  ngOnInit() {
    this.canvas.nativeElement.height = Math.floor(window.innerHeight * (0.50));
    this.canvas.nativeElement.width = Math.floor(window.innerWidth);
    this.standardLineSize = Math.floor(this.canvas.nativeElement.height / 10);
    console.log('Canvas height:', this.canvas.nativeElement.height);
    console.log('Canvas width:', this.canvas.nativeElement.width);
  }

  ngAfterViewInit(): void {
    this.context = (<HTMLCanvasElement>this.canvas.nativeElement).getContext('2d');
  }

  // analyse response from DialogFlow Agent
  analyseResponse(result) {
    const parameters = result['parameters'];
    if (result['metadata']['intentName'] === 'Tracer un trait' &&
      parameters['Directions'].length > 0 &&
      parameters['Couleurs'].length > 0 &&
      parameters['Tailles'].length > 0
    ) {
      console.log('nouveau trait');
      const path = [parameters['Directions'].toLowerCase(), parameters['Couleurs'].toLowerCase(), parameters['Tailles'].toLowerCase()];
      this.pathsTable.push(path);
      console.log(this.pathsTable);
    } else if (result['metadata']['intentName'] === 'Effacer') {
      this.pathsTable = [];
    }
    this.draw();
  }

  // draw all the paths
  draw() {
    // initial position assignement
    const lastPosition = [Math.floor(this.canvas.nativeElement.width / 2), Math.floor(this.canvas.nativeElement.height / 2)];

    this.context.clearRect(0, 0, this.canvas.nativeElement.width, this.canvas.nativeElement.height);
    for (const nextPath of this.pathsTable) {
      this.makePath(nextPath[0], nextPath[1], nextPath[2], lastPosition);
    }
  }

  // make a line
  makePath(direction, color, size, lastPosition) {

    const orientation = this.directionTable[direction];
    switch (orientation) {
      case 'up':
        this.makeUpPath(color.toLowerCase(), size, lastPosition);
        break;
      case 'down':
        this.makeDownPath(color.toLowerCase(), size, lastPosition);
        break;
      case 'right':
        this.makeRightPath(color.toLowerCase(), size, lastPosition);
        break;
      case 'left':
        this.makeLeftPath(color.toLowerCase(), size, lastPosition);
        break;
    }

  }

  // make a line to the top
  makeUpPath(color, size, lastPosition) {
    // we calculate the size of the line
    const newHeight = lastPosition[1] - Math.floor(this.standardLineSize * this.sizeTable[size]);

    // we draw the line
    this.context.beginPath();
    this.context.moveTo(lastPosition[0], lastPosition[1]);
    this.context.lineTo(lastPosition[0], newHeight);
    this.context.lineWidth = 3;
    this.context.strokeStyle = color; // using picked color
    this.context.stroke();

    lastPosition[1] = newHeight;
  }

  makeDownPath(color, size, lastPosition) {
    const newHeight = lastPosition[1] + Math.floor(this.standardLineSize * this.sizeTable[size]);

    this.context.beginPath();
    this.context.moveTo(lastPosition[0], lastPosition[1]);
    this.context.lineTo(lastPosition[0], newHeight);
    this.context.lineWidth = 3;
    this.context.strokeStyle = color;
    this.context.stroke();

    lastPosition[1] = newHeight;
  }

  makeLeftPath(color, size, lastPosition) {
    const newWidth = lastPosition[0] - Math.floor(this.standardLineSize * this.sizeTable[size]);

    this.context.beginPath();
    this.context.moveTo(lastPosition[0], lastPosition[1]);
    this.context.lineTo(newWidth, lastPosition[1]);
    this.context.lineWidth = 3;
    this.context.strokeStyle = color;
    this.context.stroke();

    lastPosition[0] = newWidth;
  }

  makeRightPath(color, size, lastPosition) {
    const newWidth = lastPosition[0] + Math.floor(this.standardLineSize * this.sizeTable[size]);

    this.context.beginPath();
    this.context.moveTo(lastPosition[0], lastPosition[1]);
    this.context.lineTo(newWidth, lastPosition[1]);
    this.context.lineWidth = 3;
    this.context.strokeStyle = color;
    this.context.stroke();

    lastPosition[0] = newWidth;
  }


}



// WEBPACK FOOTER //
// ./src/app/components/drawing-section/drawing-section.component.ts